const ORG_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/;
const PUBLIC_IDENTIFIER_PATTERN = /^[a-z0-9][a-z0-9-]{2,63}$/;
const ASSET_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/;
const CONTROL_CHARACTERS =
  /[\u0000-\u001f\u007f-\u009f\u061c\u200e\u200f\u202a-\u202e\u2066-\u2069]/;

export const DEFAULT_SIBLING_PROPOSAL_MESSAGE =
  "We would like our organisations to become siblings on Unit. Would you like to connect?";

const boundedText = (value, minimum, maximum) => {
  const text = typeof value === "string" ? value.trim() : "";
  if (
    text.length < minimum ||
    text.length > maximum ||
    CONTROL_CHARACTERS.test(text)
  ) {
    throw new TypeError("The sibling proposal draft is invalid.");
  }
  return text;
};

const boundedHttpsUrl = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const text = boundedText(value, 1, 2048);
  try {
    const url = new URL(text);
    if (url.protocol !== "https:" || url.username || url.password) {
      throw new TypeError();
    }
    return url.toString();
  } catch (_error) {
    throw new TypeError("The sibling proposal draft is invalid.");
  }
};

const optionalAssetId = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value !== "string" || !ASSET_ID_PATTERN.test(value)) {
    throw new TypeError("The sibling proposal draft is invalid.");
  }
  return value;
};

export function buildSiblingProposalMessage({ sourceOrgName, targetOrgName }) {
  const source = boundedText(sourceOrgName, 2, 80);
  const target = boundedText(targetOrgName, 2, 80);
  return `Hello ${target}, ${source} would like our organisations to become siblings on Unit. As siblings, we can trade even when one economy is closed. Would you like to connect?`;
}

export function createSiblingProposalDraft(value) {
  if (
    !value ||
    typeof value !== "object" ||
    !ORG_ID_PATTERN.test(value.sourceOrgId) ||
    !PUBLIC_IDENTIFIER_PATTERN.test(value.targetPublicIdentifier)
  ) {
    throw new TypeError("The sibling proposal draft is invalid.");
  }
  const sourceOrgName = boundedText(value.sourceOrgName, 2, 80);
  const targetOrgName = boundedText(value.targetOrgName, 2, 80);
  return Object.freeze({
    sourceOrgId: value.sourceOrgId,
    sourceOrgName,
    sourceOrgAvatarAssetId: optionalAssetId(value.sourceOrgAvatarAssetId),
    sourceOrgAvatarUrl: boundedHttpsUrl(value.sourceOrgAvatarUrl),
    targetPublicIdentifier: value.targetPublicIdentifier,
    targetOrgName,
    messageText: boundedText(
      value.messageText ||
        buildSiblingProposalMessage({ sourceOrgName, targetOrgName }),
      1,
      1000,
    ),
  });
}
